import React from 'react'
import styled from 'styled-components'

import { Link } from 'react-router-dom'
import ArrowRight from '../visuals/ArrowRight'

// these sizes are arbitrary and you can set them to whatever you wish
import { css } from 'styled-components'

const sizes = {
  phone_small: 320,
  phone: 480,
  phone_landscape: 670,
  tablet: 768,
  tablet_landscape: 1024,
  desktop: 1170,
  desktop_large: 1280
}

// iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const emSize = sizes[label] / 16
  accumulator[label] = (...args) => css`
    @media (max-width: ${emSize}em) {
      ${css(...args)}
    }
  `
  return accumulator
}, {})


const Wrap = styled.header`
`

const NavWrap = styled.div`
  height: 6.5rem;
  background-color: rgba(0, 0, 0, 0.3);

  padding: 0 20px;

  @media screen and (max-width: 560px) {
    & {
      height: auto;
    }
  }
  `

const Inside = styled.div`
  max-width: 1135px;
  margin: 0 auto;

  position: relative;
  top: 50%;
  transform: translateY(-50%);

  display: flex;
  justify-content: space-between;
  align-items: center;

  ${media.tablet`
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;`}
  @media screen and (max-width: 560px) {
    & {
      top: 0;
      transform: none;
    }
  }

`

const Logo = styled(Link)`
  display: block;
  font-family: 'Source Sans Pro';
  font-size: 2rem;
  font-weight: bold;
  line-height: 2.5rem;
  color: #F2C94C;
  text-decoration: none;
  user-select: none;
`

const Navigation = styled.nav`
  display: block;
  text-align: right;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.5rem;
  color: #fff;
`

const NavigationItem = styled(Link)`
  &:not(:first-child) {
    margin-left: 3rem;
  }

  svg
  {
    margin-bottom: -0.1875rem;
    margin-left: 0.5rem;
  }
`

const NavigationAnchor = styled.a`
  &:not(:first-child) {
    margin-left: 3rem;
  }

  svg
  {
    margin-bottom: -0.1875rem;
    margin-left: 0.5rem;
  }
`

const MainNav = styled.div`
    margin-right: 6rem;
    ${media.tablet`margin-right: 1.5rem;`}

    display: inline-block;
    ${media.tablet`display: none;`}
`

const SideNav = styled.div`
    display: inline-block;
    a
    {
      font-weight: bold;
    }
    img
    {
      margin-bottom: -0.1875rem;
      margin-left: 0.5rem;
    }
`

const MobileNav = styled.div`
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
    a
    {
      font-weight: bold;
      color: white;
      display: inline-block;
    }
    img
    {
      margin-bottom: -0.1875rem;
      margin-left: 0.5rem;
    }
    display: none;
    ${media.phone`display: block;`}
`

const Header = (props) => (
  <Wrap>
    <NavWrap>
      <Inside>
        <Logo to='/'>UABible</Logo>
        <Navigation>
          <MainNav>
            <NavigationAnchor href='https://www.gvm.website/get-involved'>Contact Us</NavigationAnchor>
          </MainNav>
          <SideNav>
            <NavigationAnchor href='https://www.gvm.website/make-a-donation'>Giving</NavigationAnchor>
          </SideNav>
        </Navigation>
      </Inside>
    </NavWrap>
    <MobileNav>
      <NavigationAnchor href='https://www.gvm.website/get-involved'>Contact Us</NavigationAnchor>
      <NavigationAnchor href='https://www.gvm.website/make-a-donation'>Giving</NavigationAnchor>
    </MobileNav>
  </Wrap>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Landing/Header.js